module.exports = __webpack_public_path__ + "img/digital-tachograph.1adad080.svg";